<template>
  <ul class="physicians-last-name-filter-list">
    <li
      class="physicians-last-name-filter-item"
      v-for="letter in letters"
      :key="letter"
      :class="{ active: store.query.lastNameLetter == letter }"
    >
      <button
        type="button"
        class="physicians-last-name-filter-button"
        @click="updateLastNameLetter(letter)"
      >
        {{ letter }}
      </button>
    </li>
    <li
      class="physicians-last-name-filter-item"
      :class="{ active: store.query.lastNameLetter == '' }"
    >
      <button
        type="button"
        class="physicians-last-name-filter-button"
        @click="updateLastNameLetter('')"
      >
        {{ allLabel }}
      </button>
    </li>
  </ul>
</template>

<script>
import { PhysiciansStore } from '../stores/PhysiciansStore'

export default {
  props: {
    allLabel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      letters: [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ']
    }
  },
  computed: {
  },
  watch: {
  },
  setup() {
    const store = PhysiciansStore()
    return {
      store
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    updateLastNameLetter(letter) {
      this.store.updateLastNameLetter(letter)
    }
  },
  components: {
  }
}
</script>